var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_42_3778)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.0526,
    cy: 15,
    r: 14.0526,
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.97803 14.5042C8.97803 6.15465 21.1749 5.88528 21.1749 14.5042",
    stroke: "white",
    strokeWidth: 1.0606
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50862 19.8063C9.50862 20.0992 9.27031 20.34 8.97964 20.3041C8.67409 20.2664 8.37454 20.1961 8.08806 20.0944C7.63769 19.9345 7.22847 19.7001 6.88377 19.4047C6.53908 19.1092 6.26564 18.7585 6.07909 18.3724C5.89255 17.9864 5.79653 17.5726 5.79653 17.1548C5.79653 16.737 5.89255 16.3232 6.0791 15.9372C6.26564 15.5512 6.53908 15.2004 6.88377 14.9049C7.22847 14.6095 7.63769 14.3751 8.08806 14.2152C8.37454 14.1135 8.67409 14.0432 8.97964 14.0055C9.27031 13.9696 9.50862 14.2104 9.50862 14.5033L9.50862 17.1548L9.50862 19.8063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6447 19.8063C20.6447 20.0992 20.883 20.34 21.1737 20.3041C21.4792 20.2664 21.7788 20.1961 22.0653 20.0944C22.5156 19.9345 22.9248 19.7001 23.2695 19.4047C23.6142 19.1092 23.8877 18.7585 24.0742 18.3724C24.2608 17.9864 24.3568 17.5726 24.3568 17.1548C24.3568 16.737 24.2608 16.3232 24.0742 15.9372C23.8877 15.5512 23.6142 15.2004 23.2695 14.9049C22.9248 14.6095 22.5156 14.3751 22.0653 14.2152C21.7788 14.1135 21.4792 14.0432 21.1737 14.0055C20.883 13.9696 20.6447 14.2104 20.6447 14.5033L20.6447 17.1548L20.6447 19.8063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1367 22.4588C17.4433 22.4588 20.114 22.3628 21.97 19.181",
    stroke: "white",
    strokeWidth: 1.0606
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.53,
    y: 21.7067,
    width: 3.09341,
    height: 1.85604,
    rx: 0.928022,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.618681
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_42_3778",
    x: 0.330827,
    y: 0.278215,
    width: 29.4438,
    height: 29.4436,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.334586
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.141176 0 0 0 0 0.133333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_42_3778"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_42_3778",
    result: "shape"
  })))));
};
export default __webpack_public_path__ + "static/media/call-center-icon.c803b9ac.svg";
export { SvgComponent as ReactComponent };